import { render, staticRenderFns } from "./gsport.vue?vue&type=template&id=4af1efd4"
import script from "./gsport.vue?vue&type=script&lang=js"
export * from "./gsport.vue?vue&type=script&lang=js"
import style0 from "./gsport.vue?vue&type=style&index=0&id=4af1efd4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports